import { CompanyActionContext } from '../../../company/common/types/CompanyActionContext';
import { CompanyLicenseInformation } from '../../types/CompanyLicenseInformation';
import { LicenseMainFormViewData } from '../../licenseMainForm/types/LicenseMainFormViewData';
import { LicenseUsageDetailsResponse } from '../../../company/common/licensingGrid/types/licensing-grid-responses';
import { AddProductViewData } from '../../../company/common/addProductMenu/types/types';
import { ActionEnum } from '../../../company/common/addProductMenu/types/ActionEnum';

export interface LicensePrePaidFormViewData {
  context: CompanyActionContext;
  companyId?: string;
  companyVisibilityTree?: string;
  canBeManagedByAbove?: boolean;
  companyLicenseInformation?: CompanyLicenseInformation;
  licenseUsageDetails?: LicenseUsageDetailsResponse;
  action?: ActionEnum;
  hasMdrSendCodeButtonUnderEmail?: boolean;
}

export namespace LicensePrePaidFormViewData {
  export function getLicensePrePaidFormViewData(
    viewData: LicenseMainFormViewData | AddProductViewData
  ): LicensePrePaidFormViewData {
    const licensePrePaidViewData: LicensePrePaidFormViewData = {
      context: viewData.context,
    };

    switch (viewData.context) {
      case CompanyActionContext.Create:
        licensePrePaidViewData.companyLicenseInformation = (<LicenseMainFormViewData>(
          viewData
        )).companyLicenseInformation;
        licensePrePaidViewData.hasMdrSendCodeButtonUnderEmail = false;
        licensePrePaidViewData.canBeManagedByAbove = viewData.company?.specifics.canBeManagedByAbove;
        break;
      case CompanyActionContext.MyCompany:
      case CompanyActionContext.Edit:
        licensePrePaidViewData.licenseUsageDetails = (<AddProductViewData>viewData).licenseUsageDetails;
        licensePrePaidViewData.action = (<AddProductViewData>viewData).action;
        licensePrePaidViewData.companyId = (<AddProductViewData>viewData).company?._id;
        licensePrePaidViewData.companyVisibilityTree = (<AddProductViewData>viewData).company?.visibilityTree;
        licensePrePaidViewData.hasMdrSendCodeButtonUnderEmail = true;
        break;
    }

    return licensePrePaidViewData;
  }
}
